class DebugConsole {
  track(event, data) {
    console.log('TRACK', event, data);
  }
}

export default DebugConsole;
